import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../redux/actions';
import Loading from '../Loading';
import '../styles/lookup.scss';

import ContactsRoundedIcon from '@mui/icons-material/ContactsRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';

let autoDownloadStarted = false;

const Contacts = (props) => {
  const [status, setStatus] = useState('downloading');

  const download = () => {
    setStatus('downloading');
    props.downloadEmployeesVcf(
      props.authToken,
      () => setStatus('success'),
      () => setStatus('error')
    );
  };

  useEffect(() => {
    props.showNav(true);
    if (autoDownloadStarted) return;
    autoDownloadStarted = true;
    download();

    return () => {
      window.setTimeout(() => {
        autoDownloadStarted = false;
      }, 1000);
    };
  }, []);

  const statusMessage = {
    downloading: 'Preparing your contacts file...',
    success: 'Download started. Import the file into your phone or email app.',
    error: 'Download failed. Please try again.',
  }[status];

  return (
    <div className="lookup-container lookup-contacts-page">
      {props.loading ? (
        <div
          className="loading-container-background"
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            zIndex: '9999',
          }}
        >
          <Loading
            loading={props.loading}
            loadingMessage={props.loadingMessage}
            location={{ top: '50%', left: '50%', height: '100%' }}
            height="120px"
          />
        </div>
      ) : null}

      <div className="lookup-hero">
        <div className="lookup-contacts-icon-wrap">
          <ContactsRoundedIcon className="lookup-contacts-icon" />
        </div>
        <h1 className="lookup-hero-title">Employee Contacts</h1>
        <p className="lookup-hero-subtitle">{statusMessage}</p>

        <div className="lookup-contacts-actions">
          {(status === 'success' || status === 'error') && (
            <button type="button" className="lookup-contacts-download-btn" onClick={download}>
              <DownloadRoundedIcon />
              Download again
            </button>
          )}

          <a href="/lookup" className="lookup-panel-footer-link lookup-contacts-back-link">
            <ArrowBackRoundedIcon />
            Back to Lookup
          </a>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    authToken: state.authToken,
    loading: state.loading,
    loadingMessage: state.loadingMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Contacts);
